import React, { useEffect, useRef } from "react";

// Import Ionic
import { IonSelect } from "@ionic/react";
import { Capacitor } from "@capacitor/core";

// Import Styles
import classNames from "classnames/bind";
import commonFormStyles from "../UI/CommonFormElements/CommonFormElements.module.scss";
import { useTranslation } from "react-i18next";

interface ISelect {
  value: any;
  placeholder: string;
  okText?: string;
  cancelText?: string;
  disabled: boolean;
  onChange: any;
  isValid?: boolean;
  className?: string;
  selectClassName?: string;
  onDismiss?: () => void;
  isAddressSelectOpen?: boolean;
}

const commonForm = classNames.bind(commonFormStyles);

const Select: React.FC<ISelect> = ({
  value,
  placeholder = "",
  disabled = false,
  onChange,
  okText,
  cancelText,
  isValid = true,
  className = "",
  selectClassName = "",
  onDismiss,
  isAddressSelectOpen,
  ...props
}) => {
  const selectRef = useRef<HTMLIonSelectElement | null>(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (isAddressSelectOpen && selectRef.current) {
      selectRef.current.click();
    }
  }, [isAddressSelectOpen]);

  return (
    <IonSelect
      key={value?.toString()}
      ref={selectRef}
      className={`${commonForm("commonElement", "commonElementSelect", {
        commonInvalid: !isValid,
      })} ${selectClassName}`}
      value={value}
      placeholder={placeholder}
      onIonChange={(e) => {
        onChange?.(e);
      }}
      interfaceOptions={{
        cssClass: className,
        mode: Capacitor.getPlatform() === "web" ? "md" : "ios",
        showBackdrop: false,
      }}
      onIonDismiss={onDismiss}
      interface={Capacitor.getPlatform() === "web" ? "popover" : "action-sheet"}
      disabled={disabled}
      cancelText={cancelText || t("Cancel")}
      okText={okText || t("Ok")}
    >
      {props.children}
    </IonSelect>
  );
};

export default Select;
